import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Menu, Dropdown, Button } from 'antd';
import { AlignLeftOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';
import { TAB_SIZE } from "../../constants/ThemeSetting";
import { useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive'
import Auxiliary from "util/Auxiliary";
import RequestHandler from "../../util/RequestHandler";
import { Scrollbars } from 'react-custom-scrollbars';


const tenantId = localStorage.getItem("tenantId");
const userId = localStorage.getItem("userId");

const Topbar = () => {
  const history = useHistory();
  const [tenantAccounts, setTenantAccounts] = useState([]);
  const [filteredTenantAccounts, setFilteredTenantAccounts] = useState([]);
  const [currentTenantAccount, setcurrentTenantAccount] = useState("");
  const [isGroupUser, setIsGroupUser] = useState(false);
  const isTabletOrMobileDevice = useMediaQuery({ query: "(max-device-width: 1224px)" });
  const [isVisibleDropdown, setIsVisibleDropdown] = useState(false);

  function handleMenuClick(e) {
    
    if(e.key == "search") {
      return;
    }

    if (e.key == "konsolide") {
      history.push(`/consolidated/bank`);
      return;
    }

    RequestHandler.get(`/Auth/ChangeTenant/${userId}/${e.key}`, undefined, { rawResponse: true }).then((response) => {
      if (response.status === 200) {
        RequestHandler.setUserInfo(response);
        history.push(`/home`);
        window.location.reload();
      }
    });
  }

  
  useEffect(() => {
    RequestHandler.get(`/User/GetUserTenants/${userId}`).then((response) => {
      setTenantAccounts(response);
      setFilteredTenantAccounts(response);

      response.map((tenantAccount) => {
        if (tenantAccount.id === tenantId) {
          setcurrentTenantAccount(tenantAccount.name);
        }
      });
    });

    RequestHandler.get(`/User/IsGroupUser`).then((response) => {
      setIsGroupUser(response);
    });
  }, []);

  const { locale, width, navCollapsed, navStyle } = useSelector(({ settings }) => settings);

  const searchTenant = (e) => {
    setFilteredTenantAccounts(tenantAccounts.filter(x=> x.name.toLowerCase().includes(e.target.value.toLowerCase())));
  }

  const visibleDropdown = () => {
    setIsVisibleDropdown(!isVisibleDropdown);
  }

  const menu = (
    <Scrollbars 
    autoHide
    autoHideTimeout={1000}
    autoHideDuration={200}
    autoHeight
    autoHeightMin={0}
    autoHeightMax={500}
    thumbMinSize={30}
    universal={true}>
        <Menu onClick={handleMenuClick}>
          <Menu.Item key="search">
            <div
              className="gx-search-bar gx-lt-icon-search-bar-md gx-module-search-bar gx-d-none gx-d-sm-block">
              <div className="gx-form-group">
                <input className="ant-input gx-border-0" type="search" placeholder="En az 1 harf giriniz"  onChange={searchTenant} />
                <span className="gx-search-icon gx-pointer"><i className="icon icon-search"/></span>
              </div>
            </div>
          </Menu.Item>

          {filteredTenantAccounts.map((item, index) => (
            <Menu.Item key={item.id} icon={<UserOutlined />} disabled={item.id === tenantId}>
              {item.name}
            </Menu.Item>
          ))}
          {
            isGroupUser === true ? <Menu.Item key="konsolide" icon={<AlignLeftOutlined />}>
              Konsolide
            </Menu.Item>
              : null
          }
        </Menu>
    </Scrollbars> 

  );
  const handleVisibleChange = (visible) => {
    if (!visible) 
      setIsVisibleDropdown(false);
  };
  return (
    <ul className="gx-header-notifications gx-ml-auto">
      <Dropdown overlay={menu} visible={isVisibleDropdown} onVisibleChange={handleVisibleChange}>
        <Button type="primary" style={{ marginTop: 19 }} onClick={visibleDropdown} >
          {isTabletOrMobileDevice ? null : currentTenantAccount}   <DownOutlined />
        </Button>
      </Dropdown>
      {width >= TAB_SIZE ? null :
        <Auxiliary>
          <li className="gx-user-nav"></li>
        </Auxiliary>
      }
    </ul>
  );
};

export default Topbar;
